export default {
  default: () => import("/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/layouts/empty.vue").then(m => m.default || m)
}